/* eslint-disable no-restricted-syntax */

/*
THIS IS AN AUTO GENERATED FILE
DO NOT EDIT THIS FILE DIRECTLY
This file is generated with the npm prestart and prebuild hooks
*/

/**
  * Import config files for each portal
  * @param {string} portal - portal name
  * @returns {Promise<any>} - config object
  */
export const configImport = async (portal) => {
  switch (portal) {
    case 'adb':
      return await import('./portals/adb/config.json');
    case 'boatsandoutboards':
      return await import('./portals/boatsandoutboards/config.json');
    case 'boot24':
      return await import('./portals/boot24/config.json');
    case 'botenbank':
      return await import('./portals/botenbank/config.json');
    case 'botentekoop':
      return await import('./portals/botentekoop/config.json');
    case 'bs24':
      return await import('./portals/bs24/config.json');
    case 'bs24uk':
      return await import('./portals/bs24uk/config.json');
    case 'cosasdebarcos':
      return await import('./portals/cosasdebarcos/config.json');
    case 'inautia':
      return await import('./portals/inautia/config.json');
    case 'topbarcos':
      return await import('./portals/topbarcos/config.json');
    case 'yachtfocus':
      return await import('./portals/yachtfocus/config.json');
    case 'yachtworld':
      return await import('./portals/yachtworld/config.json');
    case 'youboat':
      return await import('./portals/youboat/config.json');
  }
};
